import { render, staticRenderFns } from "./_cookie-categories.vue?vue&type=template&id=edfebf1c"
import script from "./_cookie-categories.vue?vue&type=script&lang=js"
export * from "./_cookie-categories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports